import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Grid } from '@mui/material'

import { Logger, LoggerTypes } from '../../../../../../utils'
import { userRightTypes } from '../../../../../../constants'
import { Button, buttonModes, buttonTypes, Icon, iconNames, AccessControl } from '../../../../../../components'
import { FlowElementConditionCard } from '../../condition/FlowElementConditionCard'
import { FlowElementConditionDialog } from '../../condition/FlowElementConditionDialog'
import '../../../common-elements-style.scss'

export const FlowElementTaskInteractionCheckPanel = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  currentTaskInstance,
  resources,
  variables,
  parameters
  // -- refresh after saving
  // refreshAfterSaving
}) => {
  const { t } = useTranslation()
  const [openDialog, setOpenDialog] = useState(false)

  const currentChecks = (currentTaskInstance && currentTaskInstance.checks) || null

  const onClickAddTaskCheck = (e) => {
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'FlowElementTaskInteractionCheckPanel.onClickAddTaskCheck()', {})

    setOpenDialog(!openDialog)
  }

  Logger.trace(LoggerTypes.CONTAINER, 'FlowElementTaskInteractionCheckPanel.render()', {
    currentTaskInstance,
    currentChecks,
    resources,
    variables,
    parameters
  })

  return (
    <div className="FlowElementTaskInteractionCheckPanel">
      <div>
        <form>
          <Grid container spacing={2} style={{ padding: '10px', marginTop: '-4px' }}>
            {/*  Buttons [+ CONDITION]  */}
            <Grid item xs={12} sm={12} style={{ position: 'relative' }}>
              <div className="btCont">
                <AccessControl userPermissions={[userRightTypes.SCENARIO_ATTRIBUTES_EDIT]} renderNoAccess={() => <></>}>
                  <Button
                    mode={buttonModes.HEADER}
                    type={buttonTypes.BUTTON}
                    tooltip={t('flowActions.tasks.panels.interactions.resources.button_action.tooltip')}
                    onClick={onClickAddTaskCheck}
                    icon={<Icon name={iconNames.PLUS} size={14} />}
                  />
                </AccessControl>
              </div>
              <div>
                {(currentChecks &&
                  currentChecks.length > 0 &&
                  currentChecks.map(
                    (check, index) =>
                      check && (
                        <FlowElementConditionCard
                          key={`task-check-${index}`}
                          currentProject={currentProject}
                          currentScenario={currentScenario}
                          currentFlowGroup={currentFlowGroup}
                          currentTaskInstance={currentTaskInstance}
                          currentCheck={check}
                          // refreshAfterSaving={refreshAfterSaving}
                        />
                      )
                  )) || (
                  <i className="notFound">{t('flowActions.tasks.panels.interactions.conditions.panels.not_found')}</i>
                )}
              </div>
            </Grid>
          </Grid>
        </form>
        {openDialog && (
          <FlowElementConditionDialog
            currentProject={currentProject}
            currentScenario={currentScenario}
            currentFlowGroup={currentFlowGroup}
            currentTaskInstance={currentTaskInstance}
            resources={resources}
            variables={variables}
            parameters={parameters}
            openDialog={openDialog}
            setOpenDialog={setOpenDialog}
            // refreshAfterSaving={refreshAfterSaving}
          />
        )}
      </div>
    </div>
  )
}

FlowElementTaskInteractionCheckPanel.displayName = 'FlowElementTaskInteractionCheckPanel'

FlowElementTaskInteractionCheckPanel.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object.isRequired,
  currentTaskInstance: PropTypes.object,
  resources: PropTypes.arrayOf(PropTypes.object),
  variables: PropTypes.arrayOf(PropTypes.object),
  parameters: PropTypes.arrayOf(PropTypes.object)
  // -- refresh after saving
  // refreshAfterSaving: PropTypes.func
}

FlowElementTaskInteractionCheckPanel.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  currentTaskInstance: null,
  resources: [],
  variables: [],
  parameters: []
  // -- refresh after saving
  // refreshAfterSaving: null
}
